<template>
  <div data-tour-scope="setting-permissions">
    <v-main>
      <v-container fluid fill-height>
        <v-layout justify-center align-center v-resize="onResize">

          <v-card width="100%" outlined elevation-0>
            <v-toolbar flat class="border_bottom" shaped>
              <v-toolbar-title>
                {{ this.$vuetify.lang.t('$vuetify.front.permissions') }}
              </v-toolbar-title>
              <v-btn class="ml-6" outlined color="primary" data-tour="tutorial" @click="tour.start()"><v-icon left>mdi-school-outline</v-icon>Tutorial guidato</v-btn>
              <v-spacer></v-spacer>
              <v-spacer></v-spacer>
              <v-toolbar-items shift>
              </v-toolbar-items>
            </v-toolbar>


            <v-container fluid v-if="rendered" data-tour="roles">
              <template v-for="(role,index_role) in this.item.role">
                <v-row>
                  <v-col cols="12" class="pt-0 pb-0">
                    <v-subheader><strong>{{getName(role.name)}}</strong></v-subheader>
                  </v-col>
                  <v-col cols="12" sm="3" md="3" v-for="(module,index) in item.permissions.list" :key="'module'+index" class="ma-0 pl-2 pr-2 pt-0 pb-0">
                    <v-checkbox :label="module" color="primary" hide-details dense v-model="role.modules.includes(module)" @change="permissionHandling($event, index_role, module)"></v-checkbox>
                  </v-col>
                </v-row>

                <v-flex md12 class="d-flex pa-5">
                  <v-divider class="marg-title"></v-divider>
                </v-flex>

              </template>


            </v-container>


            <v-flex class="pa-4" style="text-align: right">
              <v-btn depressed color="primary" class="mr-2 mt-3" data-tour="save" @click="save">
                Salva configurazione
              </v-btn>
            </v-flex>
          </v-card>
          <v-snackbar v-model="snackbar.snackbar" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'"
                      :timeout="snackbar.timeout" :vertical="snackbar.mode === 'vertical'">
            {{ snackbar.text }}
            <v-btn dark text
                   @click="snackbar.snackbar = false">
              Close
            </v-btn>
          </v-snackbar>
        </v-layout>
      </v-container>

    </v-main>
    <TourOverlay :tour="tour"></TourOverlay>
  </div>
</template>

<script>

import axios from 'axios'
import TourOverlay from '@/components/core/tour/TourOverlay.vue';
import { useTour } from '@/components/core/tour/useTour';
import { createPermissionsTourSteps } from './permissions-tour';
import {mapGetters, mapMutations, mapActions} from 'vuex';

export default {
  name: "Permissions",
  components: {
    TourOverlay,
  },
  setup() {
    return { tour: useTour(createPermissionsTourSteps()) };
  },
  beforeDestroy() {
    this.tour.stop();
  },
  data() {
    return {
      rendered: false,
      item: {
        role:[],
        permissions:{
          list:[]
        }
      },
      snackbar: {
        snackbar: false,
        color: '',
        mode: '',
        timeout: 6000,
        text: '',
      },
    }
  },

  async created() {
    this.setPreload(true);
    this.item = await this.getList();
    this.rendered = true;
    this.setPreload(false);
  },

  computed: {
    ...mapGetters({

    }),
  },

  methods: {
    ...mapMutations({
      'setPreload': 'settings/setPreload',
    }),
    ...mapActions({
      'getList': 'permissions/getList',
      'updateItem': 'permissions/permissionUpdate'
    }),
    getName(name){
      switch (name) {
        case "admin":
          return "Admin"
        case "employee":
          return "Dipendente"
        default:
          return name
      }
    },
    isEnabled(index_role, module){
      return this.item.role[index_role].modules.includes(module)
    },
    permissionHandling($event, index_role, module){
      if($event){
        this.item.role[index_role].modules.push(JSON.parse(JSON.stringify(module)))
      }else {
        this.item.role[index_role].modules = this.item.role[index_role].modules.filter((x)=>{
          return x !== module
        })
      }
    },
    async save() {

      this.setPreload(true);

      let result = await this.updateItem(this.item.role)

      if(result.success){

        this.setPreload(false);
        this.snackbar.color = "success";
        this.snackbar.text = "Operazione effettuata con  successo";
        this.snackbar.snackbar = true;
        this.snackbar.mode = 'multi-line';
        this.snackbar.timeout = 5000;

      }else {

        this.snackbar.color = "error";
        this.snackbar.text = result;
        this.snackbar.snackbar = true;
        this.snackbar.mode = 'multi-line';
        this.snackbar.timeout = 5000;
        this.setPreload(false);

      }

    },

    onResize() {
      this.isMobile = window.innerWidth < 769;
    },


  },
  beforeDestroy() {
    this.destroyData()
  }
}
</script>

<style>

</style>
